<template>
  <div :style="style" class="nav-component-container">
    <button @click="handleBtnClick()" class="nav-btn" :class="{'nav-btn-round':control.data.data.round&&!control.data.data.circle,'nav-btn-circle':control.data.data.circle,'full-width':control.data.data.fullwidth&&!control.data.data.circle}" style="border:1px solid" :style="{'color':control.data.data.label.color,'background-color':control.data.data.outlined?'#ffffff':control.data.data.btn.color,'border-color':control.data.data.btn.color,'border-width':control.data.data.plain?'0px':'1px'}">
        <span class="iconfont" :class="control.data.data.icon" v-if="control.data.data.icon!=''&&control.data.data.icon_pos==BTN_ICON_POS_LEFT"></span>
        <span :style="{'margin-right:2px':control.data.data.icon_pos==BTN_ICON_POS_RIGHT,'margin-left:2px':control.data.data.icon_pos==BTN_ICON_POS_LEFT}" v-if="!control.data.data.circle">{{control.data.data.label.text}}</span>
        <span class="iconfont" :class="control.data.data.icon" v-if="control.data.data.icon!=''&&control.data.data.icon_pos==BTN_ICON_POS_RIGHT"></span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'Add2contactComponent',
  data(){
    return {
      style:'',
      BTN_ICON_POS_LEFT:1,
      BTN_ICON_POS_RIGHT:2
    }
  },
  props: {
    control: null
  },
  methods:{
    handleBtnClick(){

      const vcard=this.control.data.data.vcard;
      
      const data= "BEGIN:VCARD\r\nVERSION:3.0\r\nN:"+vcard.lastname+";"+vcard.firstname+"\r\nFN:"+vcard.firstname+" "+vcard.lastname+"\r\nORG:"+vcard.company+"\r\nTITLE:"+vcard.job+"\r\nADR:;;"+vcard.street+";"+vcard.city+";"+vcard.state+";"+vcard.zip+";"+vcard.country+"\r\nTEL;WORK;VOICE:"+vcard.phone+"\r\nTEL;CELL:"+vcard.mobile+"\r\nTEL;FAX:"+vcard.fax+"\r\nEMAIL;WORK;INTERNET:"+vcard.email+"\r\nURL:"+vcard.website+"\r\nEND:VCARD";

      var c = document.createElement("a");

      c.download = "contact.vcf";

      var t = new Blob([data], {
                  type: "text/plain"
                  });

      c.href = window.URL.createObjectURL(t);

      c.click();

    }
  },
  updated(){

      

  },
  mounted(){


  },
  created(){
    
    this.style=this.$common.generateStyle(this.control.data.style);


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .nav-component-container{
    text-align: center;
  }

  .nav-btn{
    padding: 0.75rem 1.25rem;
    font-size: 1rem;
    transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
    border-radius: 6px;
    text-align: center;
  }

  .nav-btn-round{
    border-radius: 2rem !important;
  }

  .nav-btn-circle{
    padding: 0.75rem !important;
    border-radius: 50% !important;
  }

  .full-width{
    width: 100%;
  }

</style>
